var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckConfirm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#b1bcac"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m788.28 429.12-260.16 260.04-116.4-116.4c-15-15-39.48-15-54.48 0s-15 39.48 0 54.48l143.64 143.64c7.5586 7.5586 17.398 11.281 27.238 11.281s19.68-3.7188 27.238-11.281l287.4-287.28c15-15 15-39.48 0-54.48-15.121-15.121-39.48-15.121-54.48 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m600 120c-264.72 0-480 215.28-480 480s215.28 480 480 480 480-215.28 480-480-215.28-480-480-480zm0 882.96c-222.12 0-402.96-180.72-402.96-402.96 0-222.24 180.84-402.96 402.96-402.96s402.96 180.72 402.96 402.96-180.84 402.96-402.96 402.96z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckConfirm);
export default __webpack_public_path__ + "static/media/checkConfirm.51d63cfeb4ab399e2b16a72ea8878938.svg";
export { ForwardRef as ReactComponent };